export default function CTASection() {
  return (
    <section className="relative w-full py-24 md:py-32 px-6 md:px-10 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20wide%20panoramic%20composition%20of%20diverse%20fashion%20items%20and%20accessories%20arranged%20horizontally%20on%20a%20textured%20light%20grey%20linen%20surface%20with%20warm%20sunlight%20wash%2C%20editorial%20lifestyle%20aesthetic%2C%20soft%20cream%20grey%20and%20warm%20ivory%20tones%2C%20sophisticated%20relaxed%20composition%2C%20professional%20product%20photography%2C%20high%20detail%2C%20shallow%20depth%20of%20field%2C%20aspirational%20mood&width=1600&height=700&seq=cta-bg-v2-01&orientation=landscape"
          alt="OOPBuy Spreadsheet call to action background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/30 to-black/40"></div>
      </div>

      <div className="relative z-10 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-10">
          <div className="lg:w-1/2">
            <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-extrabold text-white leading-[0.95] mb-6">
              get your oopbuy<br />
              access now
            </h2>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="group inline-flex items-center gap-3 px-6 py-3.5 rounded-full bg-white text-foreground-900 text-base font-semibold hover:bg-background-100 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              Visit Platform
              <span className="w-7 h-7 flex items-center justify-center rounded-full bg-foreground-900 text-white group-hover:translate-x-0.5 transition-transform duration-200">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </a>
          </div>

          <div className="lg:w-1/3">
            <p className="text-white/80 text-sm md:text-base leading-relaxed">
              Ready to streamline your product sourcing? Head over to the main OOPBuy 
              platform and start exploring thousands of curated products with the spreadsheet 
              that thousands of buyers already trust.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}